import React from 'react'
import { Link } from 'react-router-dom';
import media from "../../../../media"

const ProductTable = ({productList}) => {
  
  return (
    <table className="table table-bordered m-0 border radius-remove all_domain_table table-stripd text-center">
      <thead className="text-white bg-gray-700">
        <tr>
          <th className="font-weight-bolder font-size-lg all_table_id_number">
            Id
          </th>
          <th className="width">Product Image</th>
          <th className="width">Product Name</th>
          <th className="width">Brand Name</th>
          <th className="width">Action</th>
        </tr>
      </thead>
      <tbody>
        {productList?.length > 0 ? (
          productList?.map((dataList, index) => {
            return (
              <tr
                className="greyBackground"
                key={index.toString()}
              >
                <td>{index + 1}</td>
                <td className="">
                  <img
                    src={
                      dataList?.image
                        ? dataList?.image
                        : media.Default
                    }
                    alt=""
                    className="max-w-70px reviews_product_image"
                  />
                </td>
                <td className="font-weight-bolder text-left">
                  {dataList.name.en}
                </td>
                <td className="font-weight-bolder text-left">
                  {dataList.brand.en}
                </td>
                <td className="">
                  <Link
                    to={{
                      pathname: `/productPreview/${dataList?.productId}/${dataList?.productBase}`,
                      state: {
                        productId: dataList?.productId,
                        productBase: dataList?.productBase
                      },
                    }}
                    className="btn btn-primary font-weight-bold letter-spacing btn-md"
                  >
                    Preview
                  </Link>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan={5}>No Data Found</td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export default ProductTable